import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../shared/services/snackbar.service';
import { Jurisdiction } from '../shared/models/jurisdiction';
import { AddEditJurisdictionComponent } from './add-edit-jurisdiction/add-edit-jurisdiction.component';
import { JurisdictionService } from '../shared/services/jurisdiction.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'xp-manage-supported-jurisdiction',
    templateUrl: './manage-supported-jurisdiction.component.html',
    styleUrl: './manage-supported-jurisdiction.component.scss'
})
export class ManageSupportedJurisdictionComponent {
    displayedColumns: string[] = ['jurisdictionName', 'jurisdictionCode', 'jurisdictionOrgKey', 'dateFormat', 'action'];
    jurisdictionData!: Jurisdiction[];
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA)
        public dialogRef: MatDialogRef<ManageSupportedJurisdictionComponent>,
        private snackbarService: SnackbarService,
        private dialog: MatDialog,
        private jurisdictionService: JurisdictionService) {
        this.getAllJurisdiction();
    }

    async getAllJurisdiction() {
        await this.jurisdictionService.getAllJurisdictions().then((data => {
            this.jurisdictionData = data;
        }));
    }

    onCreateJurisdiction() {
        const dialogRef = this.dialog.open(AddEditJurisdictionComponent, {
            disableClose: true,
            data: { data: null }, height: '40vh', width: '50vw',
        })
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAllJurisdiction();
            }
        });
    }

    onDeleteJurisdiction(element: Jurisdiction) {
        var configOk = {
            title: 'Delete Jurisdiction',
            message: 'Are you sure you want to delete this jurisdiction and its details?',
            dialogType: 'warning',
            buttonType: 'ConfirmCancel',
            confirmText: 'Confirm',
            cancelText: 'Cancel',
        }
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: configOk,
            width: '30%',
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.jurisdictionService.deleteJurisdiction(element.id)
                    .then(() => {
                            this.snackbarService.successSnackBar("Jurisdiction Deleted Successfully.");
                            this.getAllJurisdiction();
                    })
                    .catch((error) => {
                        this.snackbarService.errorSnackBar("Failed to delete jurisdiction. Please try again.");
                    });
            }
        });
    }

    onEditJurisdiction(element: Jurisdiction) {
        const dialogRef = this.dialog.open(AddEditJurisdictionComponent, {
            disableClose: true,
            data: { data: element }, height: '40vh', width: '50vw',
        })
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAllJurisdiction();
            }
        });
    }
}
